package exchange.dydx.abacus.state.manager

actual class SystemUtils {
    actual companion object {
        actual val platform = Platform.web
    }
}
